const FIELDS = [["night_surcharge_pct", "Nuit 21h–06h", "default_night_surcharge_pct", 10], ["sunday_surcharge_pct", "Dimanche", "default_sunday_surcharge_pct", 10],
  ["holiday_surcharge_pct", "Jours fériés", "default_holiday_surcharge_pct", 100]];

export const surchargeMultipliers = (v, company) => Object.fromEntries(FIELDS.map(([k, , ck, dflt]) => {
  const own = v?.[k];
  const pct = own === "" || own === null || own === undefined ? (company?.[ck] ?? dflt) : Number(own);
  return [k.split("_")[0], 1 + pct / 100];
}));

export const ClientSurcharges = ({ v, setV, company }) => (
  <div data-testid="client-surcharges" className="mb-4">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {FIELDS.map(([k, label, ck, dflt]) => (
        <label key={k} className="block">
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1">Majoration {label} (%)</div>
          <input data-testid={`client-${k.replace(/_/g, "-")}`} type="number" step="0.1" min="0" className="input" value={v[k] ?? ""}
            placeholder={`${company?.[ck] ?? dflt} (Paramètres)`} onChange={(e) => setV({ ...v, [k]: e.target.value })} />
        </label>
      ))}
    </div>
    <p className="text-[11px] text-slate-500 mt-2 leading-relaxed">Vide = taux de Paramètres. Les majorations se cumulent en cascade, chacune sur le total précédent (ex. samedi 21h–06h : 21h–00h nuit +10 % ; 00h–06h nuit et dimanche +10 % puis +10 %). Découpage à minuit, heure de Paris.</p>
  </div>
);
